module.exports = "/home/assets/backgrounds.13a0b774-fd18c8f51f0f33d92ee34c4eb87da65f.webp";